import { axiosCustom } from '@/plugins/axios'

export class Auth {
  authorize() {
    return '/api/v3/users/login'
  }

  getAccessToken(code) {
    const params = new URLSearchParams({
      code: code,
    }).toString()

    return axiosCustom.get(`/v3/users/callback?${params}`).then((response) => response.data)
  }
}
